module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-status",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "container"
  }, [_c('i', {
    staticClass: "form-status__icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-status__title"
  }, [_vm._v(_vm._s(_vm.title0))]), _vm._v(" "), _c('div', {
    staticClass: "form-status__message"
  }, [_vm._v(_vm._s(_vm.message0))]), _vm._v(" "), _c('div', {
    staticClass: "form-status__action"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      'btn_inverse': _vm.theme === 'inverse'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        Ok\n      ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9b6a6a7c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b6a6a7c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/FormStatus.vue
// module id = 126
// module chunks = 0